import React from 'react';

const RichText = ({ settings }) => {
    const { title, text, alignment = 'center' } = settings;

    return (
        <section className={`py-12 bg-white text-${alignment}`}>
            <div className="w-[80%] md:w-[90%] sm:w-[90%] lg:w-[90%] mx-auto">
                {title && (
                    <h2 className="text-3xl font-bold mb-6 text-slate-900">{title}</h2>
                )}
                {text && (
                    <div className="text-slate-600 text-lg leading-relaxed whitespace-pre-wrap">
                        {text}
                    </div>
                )}
            </div>
        </section>
    );
};

export default RichText;
